<template>
  <div class="fff" />
</template>
<script>
export default {
  name: "Demo",
  data: () => ({
    dayChecklistRecord: [
      {
        date: "2020年4月",
        duration: [
          {
            durationDate: "2020年4月15日",
            recordList: [
              {
                systemClass: "環保",
                unRecord_data_table: {
                  columnHeader: [
                    {
                      id: "classification",
                      textLabel: "分類",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "subCategory",
                      textLabel: "子領域",
                      type: "chips",
                      tabletHide: false
                    },
                    {
                      id: "name",
                      textLabel: "名稱",
                      type: "text",
                      tabletHide: false,
                      overflowHide: true
                    },
                    {
                      id: "checker",
                      textLabel: "答題者",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "condition",
                      textLabel: "狀態",
                      type: "text",
                      tabletHide: false
                    }
                  ],
                  rowData: [
                    {
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      checker: "陳白翔",
                      condition: "尚未覆核"
                    },
                    {
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      checker: "陳白翔",
                      condition: "尚未覆核"
                    }
                  ]
                },
                record_data_table: {
                  columnHeader: [
                    {
                      id: "result",
                      textLabel: "結果",
                      type: "icon",
                      tabletHide: false
                    },
                    {
                      id: "classification",
                      textLabel: "領域",
                      type: "text",
                      tabletHide: true
                    },
                    {
                      id: "subCategory",
                      textLabel: "子領域",
                      type: "chips",
                      tabletHide: false
                    },
                    {
                      id: "name",
                      textLabel: "名稱",
                      type: "text",
                      tabletHide: false,
                      overflowHide: true
                    },
                    {
                      id: "passRate",
                      textLabel: "合規率",
                      type: "text",
                      tabletHide: true
                    },
                    {
                      id: "checker",
                      textLabel: "答題者",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "record_at",
                      textLabel: "填表日期",
                      type: "text",
                      tabletHide: true
                    },
                    {
                      id: "reviewer",
                      textLabel: "覆核者",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "condition",
                      textLabel: "狀態",
                      type: "text",
                      tabletHide: false
                    }
                  ],
                  rowData: [
                    {
                      recordId: 1,
                      result: "icon-risk-high-filled",
                      risk: "red",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      passRate: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    },
                    {
                      recordId: 2,
                      result: "icon-risk-medium-filled",
                      risk: "blue",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      compliance: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    },
                    {
                      recordId: 3,
                      result: "icon-risk-medium-filled",
                      risk: "yellow",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      compliance: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    },
                    {
                      recordId: 4,
                      result: "icon-approved-filled ",
                      risk: "green",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      compliance: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    }
                  ]
                }
              }
            ]
          },
          {
            durationDate: "2020年4月3日",
            recordList: [
              {
                systemClass: "環保",
                unRecord_data_table: {
                  columnHeader: [
                    {
                      id: "classification",
                      textLabel: "分類",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "subCategory",
                      textLabel: "子領域",
                      type: "chips",
                      tabletHide: false
                    },
                    {
                      id: "name",
                      textLabel: "名稱",
                      type: "text",
                      tabletHide: false,
                      overflowHide: true
                    },
                    {
                      id: "checker",
                      textLabel: "答題者",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "condition",
                      textLabel: "狀態",
                      type: "text",
                      tabletHide: false
                    }
                  ],
                  rowData: [
                    {
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      checker: "陳白翔",
                      condition: "尚未覆核"
                    },
                    {
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      checker: "陳白翔",
                      condition: "尚未覆核"
                    }
                  ]
                },
                record_data_table: {
                  columnHeader: [
                    {
                      id: "result",
                      textLabel: "結果",
                      type: "icon",
                      tabletHide: false
                    },
                    {
                      id: "classification",
                      textLabel: "領域",
                      type: "text",
                      tabletHide: true
                    },
                    {
                      id: "subCategory",
                      textLabel: "子領域",
                      type: "chips",
                      tabletHide: false
                    },
                    {
                      id: "name",
                      textLabel: "名稱",
                      type: "text",
                      tabletHide: false,
                      overflowHide: true
                    },
                    {
                      id: "passRate",
                      textLabel: "合規率",
                      type: "text",
                      tabletHide: true
                    },
                    {
                      id: "checker",
                      textLabel: "答題者",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "record_at",
                      textLabel: "填表日期",
                      type: "text",
                      tabletHide: true
                    },
                    {
                      id: "reviewer",
                      textLabel: "覆核者",
                      type: "text",
                      tabletHide: false
                    },
                    {
                      id: "condition",
                      textLabel: "狀態",
                      type: "text",
                      tabletHide: false
                    }
                  ],
                  rowData: [
                    {
                      recordId: 1,
                      result: "icon-risk-high-filled",
                      risk: "red",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      passRate: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    },
                    {
                      recordId: 2,
                      result: "icon-risk-medium-filled",
                      risk: "blue",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      compliance: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    },
                    {
                      recordId: 3,
                      result: "icon-risk-medium-filled",
                      risk: "yellow",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      compliance: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    },
                    {
                      recordId: 4,
                      result: "icon-approved-filled ",
                      risk: "green",
                      classification: "環保",
                      subCategory: [
                        {
                          textLabel: "水污染防治",
                          leadingIcon: "icon-water"
                        }
                      ],
                      name: "空空日巡查表",
                      compliance: "60%",
                      checker: "陳白翔",
                      record_at: "2020.04.01",
                      reviewer: "王勇為",
                      condition: "尚未覆核"
                    }
                  ]
                }
              }
            ]
          }
        ]
      }
    ]
  })
};
</script>
<style lang="scss" scoped>
.jjj {
}
</style>